/* eslint-disable */
import React from 'react';
import {
  DemoGrid,
  IllustrationImage,
  Illustration,
  DescriptionTitle,
  DescriptionItem,
  ButtonPrimary,
  SectionCta,
  ButtonSecondary
} from '../../styled';
import Svg from 'react-inlinesvg';
import styled from 'styled-components';
import Arrow from '../../../../assets/icons/WebExperience_Icon-Arrow.svg';

const LeftArrow = styled(Svg)`
  width: 10px;
  transform: rotate(180deg);
`;

const RightArrow = styled(Svg)`
  width: 10px;
`;

const ContactButton = styled(ButtonPrimary)`
  width: 100%;
  font-weight: 600;
  &:hover {
    background: #005daa;
  }
`;

const Grid = ({
  selectedDemo,
  onNextDemo,
  onContact,
  onDemoStart,
  demoStep,
  demoSteps,
  advanceDemoStep,
  data,
  isMobile,
  singleDemo
}) => {
  return (
    <DemoGrid>
      <Illustration smallDemo={singleDemo}>
        <IllustrationImage
          src={demoStep === demoSteps.intro ? selectedDemo.illustration : selectedDemo.illustrationOutro}
        />
      </Illustration>
      <div>
        {demoStep === demoSteps.intro && (
          <>
            <DescriptionTitle>{selectedDemo.descriptionTitle}</DescriptionTitle>
            {selectedDemo.description.map((item, index) => (
              <DescriptionItem key={index}>{item}</DescriptionItem>
            ))}
          </>
        )}
        {demoStep === demoSteps.outro && (
          <>
            <DescriptionTitle>{selectedDemo.outroTitle}</DescriptionTitle>
            {selectedDemo.outroDescription.map((item, index) => (
              <DescriptionItem key={index}>{item}</DescriptionItem>
            ))}
          </>
        )}
        <SectionCta>
          {demoStep === demoSteps.intro && (
            <ButtonPrimary responsive onClick={advanceDemoStep}>
              Start the product tour
            </ButtonPrimary>
          )}

          {demoStep === demoSteps.outro && (
            <>
              {!isMobile && <LeftArrow src={Arrow} className="icon-arrow" />}

              <ButtonSecondary addMargin onClick={onDemoStart}>
                Start over
              </ButtonSecondary>
              {data.demos.length > 1 && (
                <>
                  <ButtonSecondary onClick={onNextDemo}>Next demo</ButtonSecondary>
                  {!isMobile && <RightArrow src={Arrow} className="icon-arrow" />}
                </>
              )}
            </>
          )}
        </SectionCta>
        {demoStep === demoSteps.outro && (
          <ContactButton onClick={(e) => onContact(e, selectedDemo.demoIdentifier)}>Contact sales</ContactButton>
        )}
      </div>
    </DemoGrid>
  );
};

export default Grid;
